const columnsData = (subscriptionModalOpen) => {
  return [
    {
      title: "ID",
      dataIndex: "id",
      align: "center",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      // align: "center",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (_, record) =>
        record.status === "ACTIVE" ? "ACTIVE" : "DEACTIVE",
    },
    {
      title: "Frequency Plan",
      dataIndex: "frequencyPlan",
      key: "frequencyPlan",
      align: "center",
      render: (_, record) =>
        record.dataFrequencyPlanDto?.name
          ? record.dataFrequencyPlanDto.name +
            " - " +
            record.dataFrequencyPlanDto?.value +
            " " +
            record.dataFrequencyPlanDto?.unit
          : "-",
    },
    // {
    //   title: "Frequency Level",
    //   dataIndex: "frequencyLevel",
    //   key: "frequencyLevel",
    //   align: "center",
    //   render: (_, record) =>
    //     record.dataFrequencyPlanDto?.value && record.dataFrequencyPlanDto?.unit
    //       ? record.dataFrequencyPlanDto?.value +
    //         " " +
    //         record.dataFrequencyPlanDto?.unit
    //       : "-",
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "desc",
    //   align: "center",
    //   render: (_, record) => record.dataParsingPlanDto?.description || "-",
    // },
    {
      title: "Parsing Plan",
      dataIndex: "parsingPlan",
      key: "parsingPlan",
      align: "center",
      render: (_, record) =>
        record.dataParsingPlanDto?.name
          ? record.dataParsingPlanDto.name +
            " - " +
            record.dataParsingPlanDto?.fields?.map(
              (field, index) => (index ? ", " : "") + field?.fieldName
            )
          : "-",
    },
    // {
    //   title: "Fields",
    //   dataIndex: "field",
    //   key: "field",
    //   width: "25%",
    //   render: (_, record) =>
    //     record.dataParsingPlanDto?.fields?.map(
    //       (field, index) => (index ? ", " : "") + field?.fieldName
    //     ),
    // },
  ];
};

export default columnsData;
